<template>
  <v-autocomplete :value="value" :items="items" :item-text="itemText" :item-value="itemValue" :light="light"
                  :error-messages="errorMessages" :label="label" :required="required" :solo="solo" :readonly="readonly"
                  chips multiple @input="handleInput" no-data-text="No hay datos disponibles" :loading="loading"
                  :prepend-icon="prependIcon" :disabled="disabled">

    <template slot="prepend-item">
      <v-list-tile ripple @click="selectAll">
        <v-list-tile-action>
          <v-icon v-if="defaultToPrimera" :color="isAllSelected ? 'primary' : ''">
            {{ isAllSelected ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Seleccionar todos</v-list-tile-title>
      </v-list-tile>

      <v-list-tile v-if="defaultToPrimera" ripple @click="selectOnlyPrimera">
        <v-list-tile-action>
          <v-icon :color="isOnlyPrimeraSelected ? 'primary' : ''">
            {{ isOnlyPrimeraSelected ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Sólo primera</v-list-tile-title>
      </v-list-tile>

      <v-divider></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    itemText: String,
    itemValue: String,
    errorMessages: Array,
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    solo: Boolean,
    light: Boolean,
    readonly: Boolean,
    loading: Boolean,
    prependIcon: String,
    defaultToPrimera: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isAllSelected () {
      return this.value && this.items && this.value.length > 0 && this.value.length === this.items.length
    },
    isOnlyPrimeraSelected () {
      if (!this.value || !this.items) return false
      const primeraValues = this.items.filter(item => item.primera === true).map(item => item[this.itemValue])

      if (this.value.length === 0 || this.value.length !== primeraValues.length) return false
      return this.value.every(val => primeraValues.includes(val))
    }
  },

  watch: {
    items: {
      immediate: true,
      handler (newItems) {
        if (this.defaultToPrimera && newItems && newItems.length > 0) {
          if (!this.value || this.value.length === 0) {
            this.selectOnlyPrimera()
          }
        }
      }
    }
  },

  methods: {
    selectAll () {
      if (this.value.length === this.items.length) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.items.map(item => (item[this.itemValue])))
      }
    },
    selectOnlyPrimera () {
      if (this.isOnlyPrimeraSelected) {
        this.$emit('input', [])
      } else {
        const primeraValues = this.items.filter(item => item.primera === true).map(item => item[this.itemValue])
        this.$emit('input', primeraValues)
      }
    },
    handleInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
